import './index.scss'

jQuery(($) => {
  let $caseStudiesCarousels = $('.carousel--featured-case-studies')

  function initCarousel($carousel) {
    $carousel.owlCarousel({
      margin: 10,
      dots: false,
      nav: false,
      touchDrag: true,
      mouseDrag: true,
      slideBy: 1,
      items: 1,
      animateIn: 'fadeIn',
      animateOut: 'fadeOut',
      navText: ['prev', 'next'],
      smartSpeed: 1000,
      fluidSpeed: 1000,
      stagePadding: 30
    })
  }

  function destroyCarousel($carousel) {
    if ($carousel.hasClass('owl-loaded')) {
      $carousel
        .trigger('destroy.owl.carousel')
        .removeClass('owl-carousel owl-loaded')
      $carousel.find('.owl-stage-outer').children().unwrap()
    }
  }

  function handleCarousel() {
    let windowWidth = $(window).width()

    $caseStudiesCarousels.each((index, element) => {
      let $carousel = $(element)

      if (windowWidth <= 767) {
        if (!$carousel.hasClass('owl-loaded')) {
          initCarousel($carousel)
        }
      } else {
        destroyCarousel($carousel)
      }
    })
  }

  handleCarousel()

  $(window).on('resize', function() {
    handleCarousel();
  })
})
